/* @flow weak */
import Label from 'components/Label';
import * as React from 'react';
import Select from 'components/Select';
import { Roles } from 'user/UserConstants';

type Props = {
  onChange?: Function,
  value: string,
  disabled?: boolean,
};

class RoleSelector extends React.Component<Props> {
  roleChanged = value => {
    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  render() {
    const options = [
      {
        label: 'Parent',
        value: Roles.parent,
      },
      {
        label: 'Student',
        value: Roles.student,
      },
      {
        label: 'Teacher',
        value: Roles.teacher,
      },
    ];

    return (
      <div>
        <Label htmlFor="" hidden>
          Role
        </Label>
        <Select
          disabled={this.props.disabled || false}
          options={options}
          placeholder="Select role"
          value={this.props.value || ''}
          onChange={this.roleChanged}
        />
      </div>
    );
  }
}

export default RoleSelector;
